import { LocalStorageValue } from './LocalStorageValue'

export class StringLocalStorageValue extends LocalStorageValue<string> {
  constructor(key: string, defaultValue?: string) {
    super(
      key,
      (v: string) => v,
      (r) => r,
      defaultValue,
    )
  }
}
